import { NgModule } from '@angular/core';
import { GACountryCode, GA_CONFIG, GA_GLOBAL_DATA } from '@domgen/dgx-fe-ga';

import { SkyFeatureShellModule } from '@sky/feature-shell';
import { environment } from '@sky/util-environment';

import { MetaDataService } from '@common/util-foundation';
import { AppComponent } from './app.component';
import { COMPONENT_MAPPING } from './cms-config/cms-component-mapping.config';
import { cmsDataUrl } from './cms-config/cms-data-url';
import { gaTagsConfig } from './ga-tags-config/ga-tags-config';

@NgModule({
  declarations: [AppComponent],
  imports: [
    SkyFeatureShellModule.forRoot({
      componentMapping: COMPONENT_MAPPING,
      gaTagsConfig,
      cmsDataUrl,
    }),
  ],
  providers: [
    { provide: 'isDevelopmentEnvironment', useValue: !environment.production }, // to enable debug logger
    MetaDataService,
    {
      provide: GA_CONFIG,
      useFactory: () => {
        return {
          countryCode: GACountryCode.GreatBritain,
          debug: false,
        };
      },
    },
    {
      provide: GA_GLOBAL_DATA,
      useValue: {
        category: 'sky-mobile-purchase-plan',
        clientName: 'Sky mobile plan',
        eventCategory: 'mobile plan purchase',
        genericpagename: 'sky-mobile-plan',
        siteName: 'Sky protect',
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
